//@ts-nocheck
import { Box } from '@mui/material';
import { XGCheckBox } from '@xg-cl/xg-cl';
import * as PropTypes from 'prop-types';
import './BookingPricingPlansPanel.css';

/**
 * Functional React component for rendering a custom booking pricing plans panel.
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the booking pricing plans panel component.
 * @param {Object} [props.data] - The data for the booking pricing plans panel component.
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the booking pricing plans panel component.
 */
const BookingPricingPlansPanel = ({
  id,
  data = {},
  setBookingData = () => {},
  isPassengerRemoving = false,
  ...rest
}) => {
  const { passengers = [] } = data;

  const checkedPassengerIds = passengers
    ?.filter((passenger) => {
      return passenger?.checked;
    })
    ?.map((passenger) => {
      return passenger?.passengerid;
    });

  const handleChecked = (id) => {
    const updatedPassengers = passengers.map((passenger) => {
      if (passenger.passengerid == id) {
        return { ...passenger, checked: !passenger.checked };
      }
      return passenger;
    });

    setBookingData({ ...data, passengers: updatedPassengers });
  };

  return (
    <Box className='booking-panel__pricing-plans' id={id} {...rest}>
      <Box className='booking-panel__pricing-plan'>
        {/*
        TODO: keep this comment for now, Will be used in the future when showing pricing plans
        <p className='booking-panel__pricing-plan__title'>Pricing Plan</p>
        <XGSelect
          name='name'
          size='large'
          onChange={(e) => console.log(e, data)}
          value={'Double Room'}
          menuItems={[
            {
              id: 'Double Room',
              value: 'Double Room',
              label: 'Double Room'
            }
          ]}
          className='booking-panel__pricing-plan__select'
        /> */}
        <Box className='booking-panel__pricing-plan__passengers'>
          {passengers?.map((passenger, index) => {
            const { passengerid, fullname } = passenger;
            return (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: isPassengerRemoving ? '12px' : '0px'
                }}
              >
                {isPassengerRemoving && (
                  <XGCheckBox
                    id={`${passengerid}`}
                    name={`${passengerid}`}
                    key={`${passengerid}`}
                    data-testid={`${passengerid}`}
                    value={`${passengerid}`}
                    checked={checkedPassengerIds?.includes(Number(passengerid))}
                    onChange={(e) => {
                      handleChecked(e.target?.id);
                    }}
                  />
                )}

                <span
                  className='booking-panel__pricing-plan__passenger'
                  key={index}
                >
                  {index + 1}. {fullname}
                </span>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

BookingPricingPlansPanel.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPassengerRemoving: PropTypes.bool,
  data: PropTypes.object,
  setBookingData: PropTypes.func
};

export default BookingPricingPlansPanel;
